import { type IScheduledListDate } from 'types/interfaces/ITypes'

import { ScheduledListDate } from '../ScheduledListDate'

import './ScheduleList.module.scss'

interface ScheduleListProps {
    onEditClick: (
        postType: string,
        postId: string,
        scheduleId: string
    ) => any
    list: IScheduledListDate[]
    date: Date | null
}

export const ScheduleList = ({
    onEditClick,
    list,
    date
}: ScheduleListProps) => {
    return (
        <div>
            {list.map((element, index) => (
                <ScheduledListDate
                    key={index}
                    onEditClick={onEditClick}
                    contentOnDate={element}
                    date={date}
                />
            ))}
        </div>
    )
}